<template v-if="item.customNode == 'Datos'">
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <v-card>

            <v-card-text>
              <v-img style="margin: 0 auto" class="d-block" width="200" height="200px"
                :src="ElEstudiante.ruta_avatar_persona ? URL_SPACE + '/' + ElEstudiante.ruta_avatar_persona : 'https://cdn-icons-png.flaticon.com/512/4696/4696725.png '">
              </v-img>
              <h2 class="mt-2 text-center">
                {{
                  ElEstudiante.nombre_apellido || "DATOS PERSONALES"
                }}
              </h2>
              <br />
              <v-expansion-panels>
                <!-- documento -->
                <v-expansion-panel>
                  <v-expansion-panel-header id="content">
                    <v-icon small>fa-id-card-alt</v-icon>
                    <strong class=" px-2 primary--text">Nº de documento:</strong>
                    <template v-slot:actions>
                      <v-icon x-small color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="text-center" id="content2">
                    {{ ElEstudiante.numdoc_persona }}
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- fecha de nacimiento -->
                <v-expansion-panel>
                  <v-expansion-panel-header id="content">
                    <v-icon small>fa-calendar-alt</v-icon>
                    <strong class="px-2 primary--text">Fecha de nacimiento:</strong>
                    <template v-slot:actions>
                      <v-icon x-small color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="text-center" id="content2">
                    {{ ElEstudiante.fecnac_persona }}
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- nacionalidad -->
                <v-expansion-panel>
                  <v-expansion-panel-header id="content">
                    <v-icon small>fa-flag</v-icon>
                    <strong class="px-2 primary--text">Nacionalidad:</strong>
                    <template v-slot:actions>
                      <v-icon x-small color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="text-center" id="content2">
                    {{ getNacionalidadDesc(ElEstudiante.id_pais) }}
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>




              <!-- <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header id="content">
                        <strong style="color: #1565c0"
                          >Documentos del estudiante:</strong
                        >
                        <v-icon>fa-flag</v-icon>
                        <template v-slot:actions>
                          <v-icon color="primary"> $expand </v-icon>
                        </template>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content id="content2">
                        <v-list>
                          <v-list-item @click="verItem()">
                            <v-list-item-icon>
                              <v-icon color="green">fa-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Visualizar</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels> -->
              <!------->

              <br />
              <h2>DATOS DEL COLEGIO</h2>
              <br />
              <!------->

              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header id="content">
                    <v-icon small>fa-phone</v-icon>
                    <strong class="px-2 primary--text">Teléfono:</strong>
                    <template v-slot:actions>
                      <v-icon x-small color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-center" id="content2">
                    {{ ElEstudiante.telf_colegio }}
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header id="content">
                    <v-icon small>fa-id-card-alt</v-icon>
                    <strong class="px-2 primary--text">Colegio:</strong>
                    <template v-slot:actions>
                      <v-icon x-small color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="text-center" id="content2">
                    {{ ElEstudiante.nombre_colegio }}
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header id="content">
                    <v-icon small>fa-envelope</v-icon>
                    <strong class="px-2 primary--text">Correo:</strong>
                    <template v-slot:actions>
                      <v-icon x-small color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content id="content2" class="text-center">
                    {{ ElEstudiante.responsable_correo }}
                  </v-expansion-panel-content>
                </v-expansion-panel>


                <v-expansion-panel>
                  <v-expansion-panel-header id="content">
                    <v-icon small>fa-map-marker-alt</v-icon>
                    <strong class="primary--text px-2">Dirección:</strong>
                    <template v-slot:actions>
                      <v-icon x-small color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content id="content2" class="text-center">
                    {{ ElEstudiante.direc_colegio }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>


            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="8">
          <v-card>
            <v-card-title dark class="primary pt-9 pr-5 pl-9 pb-9">
              <span class="headline">
                <h3 style="color: white">
                  {{ ElEstudiante.nombre_apellido }}
                </h3>
              </span>
            </v-card-title>
            <v-card-text>
              <br />
              <h1 style="color: #1565c0">Perfil</h1>
              <v-divider color="#1565c0" class="mt-2"></v-divider>
              <br />
              <p>
                Perfil estudiantil del colegio
                {{ ElEstudiante.nombre_colegio }}
              </p>
              <br />
              <h1 class="primary--text">Formación académica</h1>

              <v-divider color="#1565c0" class="mt-2"></v-divider>
              <br />
              <!---->

              <div>
                <v-timeline :reverse="true" :dense="$vuetify.breakpoint.smAndDown">
                  <v-timeline-item v-for="n in 2" :key="n" color="warning">
                    <v-chip slot="opposite">
                      <h2 style="color: #1565c0">
                        {{ ElEstudiante.nom_anolectivo }}
                      </h2>
                    </v-chip>

                    <v-card class="elevation-2">
                      <v-card-text>
                        <h2 style="color: #1565c0">
                          {{ ElEstudiante.nombre_colegio }}
                        </h2>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </div>
              <!---->´

              <!-- tabla de documentación -->
              <v-card height="600px">
                <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                  <h3>Documentos del estudiante</h3>
                </v-alert>
                <v-row>
                  <v-col cols="12">
                    <ComundataTablecomp dense :headers="CarpetaEstudianteheadersDoc" :items="listDocReq"
                      no-results-text="Sin documentos adjuntos">
                      <template v-slot:nombre="{ item }">
                        <strong>{{ item.nombre.replace(".pdf", "") }}</strong>
                      </template>
                      <template v-slot:ruta="{ item }">
                        <ButtonComp @click="openVisorPDF(item.ruta)" verButton tooltipText="Ver documento" />
                      </template>
                    </ComundataTablecomp>

                  </v-col>
                </v-row>
              </v-card>

            </v-card-text>
          </v-card>
          <v-dialog v-model="dialogDocumentos" persistent max-width="1000px">
            <v-card>
              <v-card-title class="btn_otro">
                <v-row class="d-flex justify-space-between py-2">
                  VER DOCUMENTO
                  <v-btn fab dark x-small class="btn_style3" @click="dialogDocumentos = false"><v-icon
                      dark>fa-times</v-icon></v-btn>
                </v-row>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <!-- <iframe :src='verPdfDoc'></iframe> -->
                      <iframe :src="verPdfDoc" type="application/pdf" width="100%" height="800px"></iframe>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- <DetallePostulante v-if="editedItem.id" @close="cerrarModal" :estado="compEstado" :postulante="editedItem">
    </DetallePostulante> -->
  </v-card>
</template>

<script>
import {  BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import ComundataTablecomp from "../../../components/ComponentsEst/ComundataTablecomp.vue";
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";
import { CarpetaEstudianteheadersDoc } from "../../../helpers/headersTable";


export default ({
  name: 'DatosPersonales',
  props: ["ElEstudiante", "Nacionalidades", "listDocReq", "servidor"],
  components: {
    ComundataTablecomp,
    ButtonComp
  },
  data: () => {
    return {
      datoLogin: sessionStorage,
      URL_SPACE: BUCKET_ORIGIN_SPACE,

      // servidor: API_URL,
      // listDocReq: [],
      CarpetaEstudianteheadersDoc,
      verPdfDoc: null,
      dialogDocumentos: false,
      compEstado: false,
      editedItem: {
        id_colegio: sessionStorage.id_colegio,
        id_usuario: sessionStorage.id,
      },
    }
  },
  methods: {

    verItem(item) {
      console.log("datapostulantejaja", item);
      this.editedItem = Object.assign({}, item);
      this.compEstado = true;
    },

    async openVisorPDF(ruta) {

      const urlmain = this.servidor + 'admision/documentos/obtenerArchivo/' + this.datoLogin.id_colegio + '/' + ruta

      console.log(urlmain);
      this.verPdfDoc = urlmain;
      this.dialogDocumentos = true;
    },

    getNacionalidadDesc(id) {
      const nacionalidadObj = this.Nacionalidades.find(n => n.id === id);
      return nacionalidadObj ? this.capitalizeFirstLetter(nacionalidadObj.desc_nacionalidad) : "Nacionalidad desconocida";
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
  },
})

</script>
  